import { mapResponse200, mapResponse400 } from './mappers';
import {
  fetchGetNormalOfferPrices,
  type IGetNormalOfferPricesRequest,
} from 'shared/repositories/mortgage-subsidised-offers/v1/get-normal-offer-prices';

import type { IApplicationContext } from 'shared/types/applicationContext';
import type { IEtazhiBlackFridayPricesData } from 'shared/types/etazhiBlackFriday';

interface IGetNormalOfferPricesParams {
  logger: IApplicationContext['logger'];
  httpApi: IApplicationContext['httpApi'];
  realtyOfferIds: IGetNormalOfferPricesRequest['realtyOfferIds'];
}

/**
 * Код появился к проекту "Чёрная пятница" для компании "Этажи".
 * @todo: удалить в задаче CD-250843
 */
export async function getNormalOfferPrices({
  logger,
  httpApi,
  realtyOfferIds,
}: IGetNormalOfferPricesParams): Promise<IEtazhiBlackFridayPricesData | null> {
  const mappers = {
    200: mapResponse200,
    400: mapResponse400,
  };
  try {
    const response = await fetchGetNormalOfferPrices<IEtazhiBlackFridayPricesData, null>({
      httpApi,
      parameters: { realtyOfferIds },
      mappers,
    });

    return response as IEtazhiBlackFridayPricesData;
  } catch (ex) {
    logger.warning(ex, { degradation: 'Ошибка получения цен для акции "Чёрная пятница" Этажи' });

    return null;
  }
}
